import React, { useState } from 'react'
import { connect } from 'react-redux'
import { toast, ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../config/settings'
import moment from 'moment'
import { Button, Dialog } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import DialogView from '../../../Dialogos/DialogView'
import { submitDemoraEnVolcadora } from '../../actions/EstadisticasVolcadorasActions'
import CamposDemoraEnVolcadora from './CamposDemoraEnVolcadora.jsx'
import { formValueSelector, reduxForm } from 'redux-form'
import { FORM_PRODUCTIVIDAD_VOLCADORAS } from '../../../../config/forms'

function CargarDemoraEnVolcadora (props) {
  const { submitDemoraEnVolcadora } = props
  const [open, setOpen] = useState(false)

  const handleOpen = () => { setOpen(true) }
  const handleClose = () => { setOpen(false) }

  const rol = props.roles.filter(roles => roles === 'SUPERVISOR' || roles === 'SUPMANTENIMIENTO' || roles === 'DESARROLLADOR')
  const rolAutorizado = (rol[0] === 'SUPERVISOR' || rol[0] === 'SUPMANTENIMIENTO' || rol[0] === 'DESARROLLADOR')

  const nuevaDemora = () => {
    const { volcadoraCamiones, motivoDemora, horaInicio, username, change: formChange, observacion } = props
    if (!props.fechaInicio && !props.fechaFin) {
      formChange('fechaInicioDemora', moment(new Date()).format('DD/MM/YYYY'))
      formChange('fechaFinDemora', moment(new Date()).format('DD/MM/YYYY'))
    }

    if (!props.horaFin) {
      formChange('horaFin', moment(new Date()).format('HH:mm'))
    }

    if (horaInicio) {
      if (volcadoraCamiones && motivoDemora) {
        if (observacion && rolAutorizado) {
          formChange('supervisor', username)
        }
        submitDemoraEnVolcadora()
        handleClose()
      } else if (!motivoDemora) {
        toast.error('Debe indicar el motivo de demora')
      } else {
        toast.error('Debe indicar la volcadora de camiones')
      }
    } else {
      toast.error('Debe indicar la hora de inicio de la demora')
    }
  }

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='md'
        fullWidth
      >
        <DialogView
          cancelCallback={handleClose}
          confirmCallback={nuevaDemora}
          title='Registro de demora en volcadora'
          content={<div style={{ margin: '2%' }}>
            <CamposDemoraEnVolcadora rolAutorizado={rolAutorizado} />
          </div>
          }
        />
      </Dialog>

      <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '22px 8px 0 0' }}>
        <Button
          variant='contained'
          size='small'
          color='primary'
          onClick={handleOpen}
        >
          <AddIcon style={{ color: '#ffffff', margin: '0 5' }} />
                    Nueva demora
        </Button>
      </div>
    </>
  )
}

const selector = formValueSelector(FORM_PRODUCTIVIDAD_VOLCADORAS)

const mapStateToProps = (state) => ({
  fechaInicio: selector(state, 'fechaInicioDemora'),
  fechaFin: selector(state, 'fechaFinDemora'),
  horaInicio: selector(state, 'horaInicio'),
  horaFin: selector(state, 'horaFin'),
  motivoDemora: selector(state, 'motivoDemora'),
  observacion: selector(state, 'observacionesDemora'),
  roles: state.auth.roles,
  username: state.auth.username,
  volcadoraCamiones: selector(state, 'volcadoraCamiones')
})

const mapActionsToProps = {
  submitDemoraEnVolcadora
}
const withRedux = connect(mapStateToProps, mapActionsToProps)

const withReduxForm = reduxForm({
  form: FORM_PRODUCTIVIDAD_VOLCADORAS,
  initialValues: {
    fechaInicioDemora: moment(new Date()).format('DD/MM/YYYY'),
    fechaFinDemora: moment(new Date()).format('DD/MM/YYYY'),
    horaFin: moment(new Date()).format('HH:mm')
  }
})

export default withRedux(withReduxForm(CargarDemoraEnVolcadora))
